'use client';

import { PASSWORD_RULES } from '@/lib/password-policy';

/** Live checklist of the password rules, shown under every new-password field. */
export function PasswordRequirements({ password, id }: { password: string; id?: string }) {
  return (
    <ul id={id} className="mt-2 space-y-1 text-sm" aria-live="polite">
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(password);
        return (
          <li key={rule.id} className={met ? 'text-green-700' : 'text-gray-600'}>
            <span aria-hidden="true">{met ? '✓' : '•'}</span> {rule.label}
            <span className="sr-only">{met ? ' (done)' : ' (required)'}</span>
          </li>
        );
      })}
    </ul>
  );
}
